// modules/clientes/pages/ClienteDetallePage.jsx
import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box, Typography, CircularProgress, Alert, Button,
  Paper, IconButton, Stack,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DashboardLayout from "../../../layouts/DashboardLayout";
import ClienteDatosTab from "../components/detalle/ClienteDatosTab";
import * as clienteService from "../services/clienteService";

const ClienteDetallePage = () => {
  const { cod_cliente } = useParams();
  const navigate = useNavigate();

  const [cliente, setCliente] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const cargarCliente = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const resCliente = await clienteService.getById(cod_cliente);
      setCliente(resCliente.data);
    } catch (err) {
      setError(err?.response?.data?.message || "Error al cargar el cliente");
    } finally {
      setLoading(false);
    }
  }, [cod_cliente]);

  useEffect(() => { cargarCliente(); }, [cargarCliente]);

  if (loading) return (
    <DashboardLayout>
      <Box sx={{ display: "flex", justifyContent: "center", p: 6 }}>
        <CircularProgress />
      </Box>
    </DashboardLayout>
  );

  if (error) return (
    <DashboardLayout>
      <Box sx={{ p: 3 }}>
        <Alert severity="error" action={
          <Button size="small" onClick={cargarCliente}>Reintentar</Button>
        }>
          {error}
        </Alert>
      </Box>
    </DashboardLayout>
  );

  return (
    <DashboardLayout>
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
          <IconButton
            onClick={() => navigate("/clientes")}
            size="small"
            sx={{ border: "1px solid", borderColor: "divider", bgcolor: "background.paper" }}
          >
            <ArrowBackIcon fontSize="small" />
          </IconButton>

          <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flexGrow: 1 }}>
            <Typography variant="h5" fontWeight={700} color="text.primary">
              {cliente.razon_social}
            </Typography>
          </Stack>
        </Box>

        <Paper sx={{ borderRadius: 2, overflow: "hidden" }}>
          <Box sx={{ p: 2 }}>
            <ClienteDatosTab
              cliente={cliente}
              onUpdate={cargarCliente}
            />
          </Box>
        </Paper>
      </Box>
    </DashboardLayout>
  );
};

export default ClienteDetallePage;
